import styled from '@emotion/styled';
import { StyledButton } from '~/shared/components';
import { StyledScrollArea } from '~/shared/components/CarouselDrag/styled';
import { breakpoints } from '~/theme';

export const StyledPagination = styled.div(({ theme }) => ({
    display: 'none',
    [breakpoints.sm]: {
        display: 'flex',
        textAlign: 'right',
        flexDirection: 'row',
        gap: theme.spaces[3],
    },
}));

export const StyledCarouselRef = styled.div<{ cardWidth: number }>(({ theme, cardWidth }) => ({
    marginTop: theme.spaces[4],
    [`${StyledScrollArea}`]: {
        paddingBottom: theme.spaces[4],
    },
    [`${StyledCarouselItem}`]: {
        width: `calc(100vw / ${cardWidth})`,
    },
}));

export const StyledCarouselItem = styled.div({
    width: '100%',
});

export const StyledCarouselContent = styled.div(({ theme }) => ({
    display: 'flex',
    gap: theme.spaces[3],
}));

export const StyledNavigationButton = styled(StyledButton)(({ theme }) => ({
    ['&:hover svg']: {
        color: theme.colors.dark70,
    },
}));
